module.exports = __webpack_public_path__ + "static/media/p9.14441ac0.jpeg";